import { SharedModule } from '../../../shared/shared.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';
import { SpinnerModule } from 'src/app/shared/spinner/spinner.module';
import { GuestComponent } from './guest.component';
import { Section2Component } from './section2/section2.component';
import { Section3Component } from './section3/section3.component';
import { Section1Component } from './section1/section1.component';
import { Section4Component } from './section4/section4.component';
import { BasicChartsModule } from 'src/app/shared/basic-charts/basic-charts.module';
const routes: Routes = [
  {
    path: '', component: GuestComponent,
  }
]

@NgModule({
  declarations: [
    GuestComponent,
    Section2Component,
    Section3Component,
    Section1Component,
    Section4Component,
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    SharedModule,
    SpinnerModule,
    BasicChartsModule,
    // TranslateModule.forChild({
    //   defaultLanguage: 'en',
    //   loader: {
    //     provide: TranslateLoader,
    //     useFactory: HttpLoaderFactory,
    //     deps: [HttpClient]
    //   },
    //   isolate: true
    // })
  ],
  exports: [
    Section2Component
  ]
})
export class GuestModule { }

// required for AOT compilation
export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http, './assets/i18n/HomePageModule/', '.json');
}
